export default __webpack_public_path__ + "static/media/debuttravauxActual.c8d05671.png";